import { createActionConst } from '../../../utils/action.utils';

const QUARTAL_NAMESPACE = 'QUARTAL';

export const STORE_QUARTAL = createActionConst(QUARTAL_NAMESPACE, 'STORE_QUARTAL');
export const CLEAR_QUARTAL = createActionConst(QUARTAL_NAMESPACE, 'CLEAR_QUARTAL');
